import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { AuthRedirectComponent } from './auth-redirect/auth-redirect.component';
import { ResetPasswordComponent } from '../../modules/compliance/headers/reset-password/reset-password.component';
import { authGuard } from './guards/auth.guard';
import { entryRedirect } from './guards/entry-redirect';
import { WeeklyReportComponent } from '../../modules/compliance/reports/standard-report/weekly-report/weekly-report.component';
import { WeeklyReportAuthRedirectComponent } from './weekly-report-auth-redirect/weekly-report-auth-redirect.component';
import { WeeklyReportOtpVerificationComponent } from './weekly-report-otp-verification/weekly-report-otp-verification.component';
import { ChangePasswordComponent } from '../../modules/compliance/headers/change-password/change-password.component';
import { LinkedExpiredComponent } from './linked-expired/linked-expired.component';
import { GlobalLogoutComponent } from '../../modules/compliance/global-logout/global-logout.component';
import { DashboardTabComponent } from './bi-integration/dashboard-tab/dashboard-tab.component';
import { resetPasswordLinkGuard } from './guards/reset-password-link.guard';
export const appRoutes: Routes = [
  //these page routes are outside of main layout and doesn't require authentication
  // Session-aware: a live sessionStorage session survives the round trip out to the
  // legacy portal, so landing back on '/' must not bounce the user to login.
  { path: '', redirectTo: entryRedirect, pathMatch: 'full' },
  {
    path: 'dashboard-tab',
    component: DashboardTabComponent,
    // Add your existing AuthGuard here if needed:
    // canActivate: [AuthGuard]
  },
  { path: 'global-logout', component: GlobalLogoutComponent },
  { path: 'login', component: LoginComponent },
  { path: 'auth-redirect', component: AuthRedirectComponent },
  { path: 'changePassword', component: ChangePasswordComponent, canActivate: [resetPasswordLinkGuard] },
  { path: 'linkedExpired', component: LinkedExpiredComponent },
  { path: 'emailVerification', component: EmailVerificationComponent },
  { path: 'resetPassword', component: ResetPasswordComponent },
  { path: 'weeklyreport', component: WeeklyReportComponent },
  {path: 'weeklyreportauthredirect', component: WeeklyReportAuthRedirectComponent},
  {path: 'weeklyreportotpverification', component: WeeklyReportOtpVerificationComponent},

  // Protect this entire lazy-loaded module
  {
    path: '',
    canActivate: [authGuard],
    canLoad: [authGuard], // optional, prevents module load
    loadChildren: () =>
      import('./routes/routes.module').then(m => m.RoutesModule)
  },
    { path: '**', redirectTo: entryRedirect }
];
